import { Button, Tooltip } from '@mui/material'
import TableChartIcon from '@mui/icons-material/TableChart'
import { exportToExcel, ExportColumn } from '../utils/exportToExcel'

export interface ExportButtonProps<T extends Record<string, any>> {
  data: T[]
  columns: ExportColumn[]
  filename?: string
  sheetName?: string
  disabled?: boolean
}

/**
 * Botão da barra de comandos: ícone + texto "Excel", visível em qualquer tema.
 */
function ExportButton<T extends Record<string, any>>({
  data,
  columns,
  filename,
  sheetName,
  disabled = false,
  showText = false,
}: ExportButtonProps<T> & { showText?: boolean }) {
  const handleExport = () => {
    exportToExcel(data, columns, { filename, sheetName })
  }

  const hasData = data && data.length > 0

  return (
    <Tooltip title={!hasData ? 'Não há dados para exportar' : 'Exportar para Excel'}>
      <span style={{ display: 'inline-block' }}>
        <Button
          variant="contained"
          size="medium"
          startIcon={<TableChartIcon />}
          onClick={handleExport}
          disabled={disabled || !hasData}
          aria-label="Exportar para Excel"
          sx={{ minWidth: showText ? 'auto' : 40, px: showText ? 2 : 1 }}
        >
          {showText && 'Excel'}
        </Button>
      </span>
    </Tooltip>
  )
}

export default ExportButton
